import { createRouter, createWebHistory } from 'vue-router';
import { isUserLoggedIn } from "@/services/UserServices";

// DAILY LINKS
import HomePage from './pages/homepage/HomePage.vue';
import DashBoard from './pages/dash/DashBoard.vue';

import MindMovie from './pages/mindmovie/MindMovie.vue';
import MmAll from './pages/mm-all/MmAll.vue';
import MindMovieV1 from './pages/mindmovie-v1/MindMovie.vue';
import MindMovieCategories from './pages/mindmoviecategories/MindMovieCategories.vue';

import WorkoutsAll from './pages/workouts/WorkoutsAll.vue';
import WorkoutLog from './pages/workouts/WorkoutLog.vue';
import WorkoutOne from './pages/workouts/WorkoutOne.vue';

import WhatDo from './pages/whatdo/WhatDo.vue';
import WhatDoNew from './pages/whatdo/WhatDoNew.vue';
import WhatDoOne from './pages/whatdo/WhatDoOne.vue';

// SOMETIMES LINKS
import SpankBank from './pages/spankbank/SpankBank.vue';
import CheatMeal from './pages/cheatmeal/CheatMeal.vue';



// WEEKLY LINKS
import WeeklyReviewPreview from '@/pages/wrp/WeeklyReviewPreview.vue';
import WrpsAll from '@/pages/wrp/WrpsAll.vue';
import WrpOne from '@/pages/wrp/WrpOne.vue';

import MenuMaker from './pages/menumaker/MenuMaker.vue';
import MenusAll from './pages/menumaker/MenusAll.vue';
import MenuOne from './pages/menumaker/MenuOne.vue';


// INFO PAGES
import FaqPage from './pages/faq/FaqPage.vue';

import MyAccount from './pages/account/MyAccount.vue';
import EditProgram from './pages/program/EditProgram.vue';
import EditReason from './pages/reason/EditReason.vue';

import SignOut from './pages/signout/SignOut.vue';

import NotFound from './pages/NotFound.vue';


const router = createRouter({
  history: createWebHistory(),
  routes: [
    // SIMPLE HOMEPAGE / LANDING PAGE
    { 
      path: '/:view?', // this targets any url while UNauthorized
      component: HomePage,
      meta: { requiresUnauth: true },
      props: true,
    },


    // DASHBOARD - mobile
    {
      path: '/m/dash',
      component: DashBoard,
      meta: { requiresAuth: true },
    },
    {
      path: '/m/dash/:todaysDate',
      component: DashBoard,
      meta: { requiresAuth: true },
      props: true,
    },
    // DASHBOARD - desktop
    {
      path: '/dash',
      component: DashBoard,
      meta: { requiresAuth: true },
    },
    {
      path: '/dash/:todaysDate',
      component: DashBoard,
      meta: { requiresAuth: true },
      props: true,
    },



    // MIND MOVIE
    {
      path: '/mindmovie',
      component: MindMovie,
      meta: { requiresAuth: true },
    },
    {
      path: '/mindmovie-v1',
      component: MindMovieV1,
      meta: { requiresAuth: true },
    },
    {
      path: '/mindmovie-categories',
      component: MindMovieCategories,
      meta: { requiresAuth: true },
    },
    {
      path: '/mm-all',
      component: MmAll,
      meta: { requiresAuth: true },
    },




    // WORKOUT LOG
    {
      path: '/workouts',
      component: WorkoutsAll,
      meta: { requiresAuth: true },
    },
    {
      path: '/workout/:workoutId',
      component: WorkoutOne,
      meta: { requiresAuth: true },
      props: true,
    },
    {
      path: '/workout',
      component: WorkoutLog,
      meta: { requiresAuth: true },
    },







    // WHATDO
    {
      path: '/whatdo',
      component: WhatDo,
      meta: { requiresAuth: true },
    },
    {
      path: '/whatdo/new',
      component: WhatDoNew,
      meta: { requiresAuth: true },
    },
    {
      path: '/whatdo/:wheelId',
      component: WhatDoOne,
      meta: { requiresAuth: true },
      props: true,
    },



    // SPANK BANK
    {
      path: '/spankbank',
      component: SpankBank,
      meta: { requiresAuth: true },
    },

    // CHEAT MEALS
    {
      path: '/cheatmeal',
      component: CheatMeal,
      meta: { requiresAuth: true },
    },





    // WRP - WEEKLY REVIEW / PREVIEW shoutout to johndaddy
    {
      path: '/wrp/all',
      component: WrpsAll,
      meta: { requiresAuth: true },
    },
    {
      path: '/wrp/:id',
      component: WrpOne,
      meta: { requiresAuth: true },
      props: true,
    },
    {
      path: '/wrp',
      component: WeeklyReviewPreview,
      meta: { requiresAuth: true },
    },





    // MENU-MAKER
    {
      path: '/menus',
      component: MenusAll,
      meta: { requiresAuth: true },
    },
    {
      path: '/menu/:menuStartDate',
      component: MenuOne,
      meta: { requiresAuth: true },
      props: true,
    },
    {
      path: '/menu',
      component: MenuMaker,
      meta: { requiresAuth: true },
    },





    // INFO PAGES
    {
      path: '/faq',
      component: FaqPage,
      meta: { requiresAuth: false },
    },
    {
      path: '/about',
      component: FaqPage,
      meta: { requiresAuth: false },
    },
    {
      path: '/contact',
      component: FaqPage,
      meta: { requiresAuth: false },
    },




    // MY ACCOUNT
    {
      path: '/account',
      component: MyAccount,
      meta: { requiresAuth: true },
    },
    {
      path: '/program/:id',
      component: EditProgram,
      meta: { requiresAuth: true },
      props: true,
    },
    {
      path: '/reason/:id',
      component: EditReason,
      meta: { requiresAuth: true },
      props: true,
    },



    // signout
    { path: '/signout', component: SignOut },
    // wildcard / 404
    { path: '/:notFound(.*)', component: NotFound },

  ],
});

router.beforeEach(function(to, _, next) {
  const userIsLoggedIn = isUserLoggedIn();
  if (to.meta.requiresAuth && !userIsLoggedIn) {
    next('/');
  } else if (to.meta.requiresUnauth && userIsLoggedIn) {
    // i.e. if logged-in user tries to go to /
    next('/dash');
  } else {
    next();
  }
});

export default router;
